import {
  Avatar,
  Badge,
  TableBody,
  TableCell,
  TableRow,
} from "@windmill/react-ui";
import MainDrawer from "components/drawer/MainDrawer";
import CheckBox from "components/form/CheckBox";
import DeleteModal from "components/modal/DeleteModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import DeleteButton from "components/table/DeleteButton";
import ReplayButton from "components/table/ReplayButton";
import ShowHideButton from "components/table/ShowHideButton";
import Tooltip from "components/tooltip/Tooltip";
import useToggleDrawer from "hooks/useToggleDrawer";
import { useTranslation } from "react-i18next";

import { t } from "i18next";
import { FiEdit, FiZoomIn } from "react-icons/fi";
import { Link } from "react-router-dom";
import { showingTranslateValue } from "utils/translate";
import React, { useState, useEffect } from 'react'
import DepartmentServices from "services/DepartementServices";
import QuoteDrawer from "components/drawer/QuoteDrawer";
import DepartmentContactServices from "services/DepartementContactServices";
import QuoteServices from "services/QuoteServices";
//internal import  

const QuoteAdminTable = ({ id, setId, data, searchQuote, isCheck, setIsCheck, currency, lang, isLoading, setIsLoading, adminprevilegesList }) => {
  const {
    handleModalOpen,
    handleUpdate,
    serviceId,
    // Destructurer d'autres valeurs ou fonctions nécessaires depuis useToggleDrawer si besoin 
  } = useToggleDrawer();
  const [status, setStatus] = useState("");
  const { t } = useTranslation();


  console.log("id from quoteTable : ", serviceId);

  const handleStatusChange = async (id, newStatus) => {
    // Mettez à jour l'état local
    setStatus(newStatus);
    // console.log("newStatus",newStatus)
    // const qu = await QuoteServices.getQuoteById(id)
    // setId([...id, qu.id]);
    const formData = { status: newStatus, };
    // console.log("fffffffff",formData)
    setIsLoading(false);


    // Appelez le service pour mettre à jour le statut dans la base de données
    QuoteServices.updateAdminQuote(id,
      formData
    )

      .then((response) => {
        // Traitez la réponse si nécessaire
        setIsLoading(true);

      })
      .catch((error) => {
        // Traitez les erreurs si nécessaire
        console.error('Error updating quote:', error);
      });
  };


  // Utilisez la fonction getAllServices pour récupérer les données des projets depuis l'API

  const getQuote = async () => {
    try {
      const qu = await QuoteServices.getQuoteById(serviceId)
      setIsCheck([...isCheck, qu.id]);
      setId([...id, qu.id]);

    } catch (error) {
      console.error("Erreur lors de la récupération de quote :", error);

    }
  }


  useEffect(() => {
    getQuote();
  }, [])

  const beforeHandleModalOpen = (id, name, Quote) => {
    handleModalOpen(id, name, Quote);
    // setIsCheck([id]);
  }
  const handleClick = (e) => {
    const { id, checked } = e.target;
    if (checked) {
      setIsCheck([...isCheck, id]);
    } else {
      setIsCheck(isCheck.filter((item) => item !== id));
    }
  };
  return (
    <>
      {/* {isCheck?.length < 1 && <DeleteModal id={serviceId} title={title} />}  */}
      {isCheck?.length < 1 && <DeleteModal
        id={serviceId}
        title={data?.first_name}
        isLoading={isLoading} // Passer la variable isLoading
        setIsLoading={setIsLoading} // Passer la fonction setIsLoadingisLoading={true} 
      />}

      {isCheck?.length < 2 && (
        <MainDrawer>
          <QuoteDrawer id={serviceId} isLoading={isLoading} setIsLoading={setIsLoading} setIsCheck={setIsCheck} isCheck={isCheck} />
        </MainDrawer>
      )}

      <TableBody>
        {data?.map((item, i) => (
          <TableRow key={i + 1}>

            <TableCell>
              <div className="flex items-center">
                <div>
                  <h2 className="text-sm font-medium">
                    #{t('Quote')} - {item.id} {/* Ajoutez un espace entre les deux variables */}
                  </h2>
                </div>
              </div>
            </TableCell>
            <TableCell>
              <div className="flex items-center">
                <div>
                  <h2 className="text-sm font-medium">
                    {item?.quoteDate} {/* Ajoutez un espace entre les deux variables */}
                  </h2>
                </div>
              </div>
            </TableCell>
            <TableCell>
              <div className="flex items-center">
                <div>
                  <h2 className="text-sm font-medium">
                    {item?.user != null ?(
                      <>
                        {item?.user?.name}
                      </>
                    ):(
                    <>
                      {item?.quote?.first_name} {" "} {item?.quote?.last_name}
                    </>)
                    }
                    {/* Ajoutez un espace entre les deux variables */}
                  </h2>
                </div>
              </div>
            </TableCell>
            <TableCell>
              <span className="text-sm">
                {item?.totalAmount}
              </span>
            </TableCell>
            <TableCell>
              <span className="text-sm">
                {item?.total}
              </span>
            </TableCell>

            <TableCell>
              <select
                value={item.status}
                onChange={(e) => handleStatusChange(item.id, e.target.value)}
                className={`px-2 py-1 rounded-full border-none`}
              >

                <option className="text-black bg-white border-none" value="Draft"> {t("Draft")}</option>
                <option className="text-black bg-white border-none" value="New">{t("New")}</option>
                <option className="text-black bg-white border-none" value="Accepted">{t("Accepted")}</option>
                <option className="text-black bg-white border-none" value="Rejected">{t("Rejected")}</option>
                <option className="text-black bg-white border-none" value="Accepted">{t("Modified")}</option>
                <option className="text-black bg-white border-none" value="Expired">{t("Expired")}</option>
              </select>
            </TableCell>





            <TableCell>
              <Link
                to={`/quotes-management/${item.id}`}
                className="flex justify-center text-gray-400 hover:text-orange-600"
              // handleUpdate={handleUpdate}

              >
                <Tooltip
                  id="view"
                  Icon={FiZoomIn}
                  title={t("DetailsTbl")}
                  bgColor="#10B981"
                />
              </Link>
            </TableCell>

            <TableCell>





              <div className="flex justify-end text-right">
                <EditDeleteButton
                  id={item.id}
                  data={item}
                  isCheck={serviceId}
                  handleClick={handleClick}
                  handleUpdate={handleUpdate}
                  handleModalOpen={beforeHandleModalOpen}
                  title={showingTranslateValue(item?.title, lang)}
                  adminprevilegesList={adminprevilegesList}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default QuoteAdminTable;
